import React, { useContext } from "react";
import { Input } from "antd";
import { WithdrawModalsContext } from "../context/WithdrawModalContext";
import errorText from "Shared/constants/errors.json";

export const CreatePaypalAccount = () => {
	const { onChangeWalletData, newWalletData, errors } = useContext(WithdrawModalsContext);
	const onChangeMethodValue = (e) => onChangeWalletData("paypal_email", e.target.value);

	return (
		<>
			<div className="withdraw-modal__row">
				<div className="withdraw-modal__row-label">PayPal</div>
				<Input
					onChange={onChangeMethodValue}
					value={newWalletData?.paypal_email}
					status={errors?.paypal_email ? "error" : ""}
				/>
				{errors?.paypal_email && (
					<div className="error-messages">
						<div className="error-messages__message">{"Please enter a valid PayPal"}</div>
					</div>
				)}
				{errors?.alredy_registered && (
					<div className="error-messages">
						<div className="error-messages__message">{errorText[errors?.alredy_registered]}</div>
					</div>
				)}
			</div>
		</>
	);
};
